class ProductCard extends HTMLElement {
    constructor() {
        super();

        this.swatch_ele = this.querySelectorAll('.product-color-swatch-wrapper .swatch')
        this.variant_item = this.querySelectorAll('.variant_list .variant_item.active .item')
        this.add_cart_btn = this.querySelector('add-cart-button')
        this.active_color
        this.enable_color_ga4 = true
        this.announceNextVariantChange = false
        this.item_name = document.getElementById('ProductGridContainer').dataset.itemName
    }
    connectedCallback() {
        this.show_hide_color()
        this.updateSwatchAccessibility(this.querySelector('.product-color-swatch-wrapper .swatch.active'))
        this.initSwatchKeyboardNav()
        this.init()
        this.syncOpenMeet2Title()
    }

    syncOpenMeet2Title() {
        if (!this.classList.contains('openmeet-2')) return

        const title = this.querySelector('.product_title_name')
        const dongleOption = Array.from(this.querySelectorAll('.variant_item')).find(item => {
            const label = item.querySelector('.variant_name')?.textContent?.trim()
            return /Dongle|Wireless Adapter|Connectivity/i.test(label || '')
        })
        const selectedOption = dongleOption?.querySelector('.item.active')
        const selectedValue = selectedOption?.getAttribute('data') || selectedOption?.textContent?.trim() || ''
        const isNoAdapter = /^no[\s-]*adapter$/i.test(selectedValue)

        if (title) {
            title.textContent = isNoAdapter ? title.dataset.noAdapterTitle : title.dataset.ucTitle
        }
    }

    show_hide_color() {
        this.swatch_ele.forEach(swatch => {
            swatch.classList.remove('hidden');
        })
        this.querySelectorAll('.variant_list .variant_item .item:not(.active)').forEach(variant => {
            this.swatch_ele.forEach(swatch => {
                if (swatch.getAttribute('data').indexOf(variant.getAttribute('data')) > -1) {
                    swatch.classList.add('hidden');
                }
            })
        })
    }

    initSwatchKeyboardNav() {
        const container = this.querySelector('.product-color-swatch-wrapper[role="group"]')
        if (!container) return

        container.addEventListener('keydown', (e) => {
            const validKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
            if (!validKeys.includes(e.key)) return

            const visibleSwatches = Array.from(container.querySelectorAll('.swatch:not(.hidden)'))
            if (visibleSwatches.length === 0) return

            const focused = document.activeElement
            const currentIndex = visibleSwatches.indexOf(focused)
            let targetIndex = currentIndex

            e.preventDefault()
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                targetIndex = (currentIndex + 1) % visibleSwatches.length
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                targetIndex = (currentIndex - 1 + visibleSwatches.length) % visibleSwatches.length
            } else if (e.key === 'Home') {
                targetIndex = 0
            } else if (e.key === 'End') {
                targetIndex = visibleSwatches.length - 1
            }

            if (targetIndex !== currentIndex && targetIndex >= 0) {
                visibleSwatches[targetIndex].focus()
                this.announceNextVariantChange = true
                visibleSwatches[targetIndex].click()
            }
        })
    }

    isVariantAnable() {
        const that = this
        const other_color_swatch = this.querySelectorAll(`.product-color-swatch-wrapper .swatch.hidden[data*='${this.active_color}']`)
        const first_variants = this.querySelectorAll('.variant_list .variant_item.active')[0]
        const last_variants = this.querySelectorAll('.variant_list .variant_item.active')[1]
        // 第一个非size变体
        if (first_variants) {
            for (const variant of first_variants.querySelectorAll('.item:not(.active)')) {
                let color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${variant.getAttribute('data')}']`)
                if (last_variants) {
                    const last_variants_active = last_variants.querySelector('.item.active').getAttribute('data')
                    color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${variant.getAttribute('data')} / ${last_variants_active}']`)
                }
                if (color_item) {
                    variant.classList.remove('disabled')
                } else {
                    variant.classList.add('disabled')
                }

            }
        }
        // 第二个非size变体
        if (last_variants) {
            const first_variants_active = first_variants.querySelector('.item.active').getAttribute('data')
            for (const variant of last_variants.querySelectorAll('.item:not(.active)')) {
                const color_item = this.querySelector(`.product-color-swatch-wrapper .swatch[data = '${that.active_color} / ${first_variants_active} / ${variant.getAttribute('data')}']`)
                if (color_item) {
                    variant.classList.remove('disabled')
                } else {
                    variant.classList.add('disabled')
                }

            }
        }
    }

    updateSwatchAccessibility(selectedSwatch) {
        this.swatch_ele.forEach(swatch => {
            const isSelected = swatch === selectedSwatch
            const defaultLabel = swatch.getAttribute?.('data-a11y-label')

            // Roving tabindex: only the active swatch is in the tab order
            swatch.setAttribute('tabindex', isSelected ? '0' : '-1')
            // Communicate selection via aria-label suffix so NVDA does not
            // announce a negative state ("not checked") for every inactive swatch.
            if (defaultLabel) {
                swatch.setAttribute('aria-label', isSelected ? `${defaultLabel}, selected` : defaultLabel)
            }
        })
    }

    getVariantOptionNames() {
        const optionNames = ['Color']

        this.querySelectorAll('.variant_list .variant_item .variant_name').forEach(optionName => {
            const label = optionName.textContent?.trim()

            if (label) {
                optionNames.push(label)
            }
        })

        return optionNames
    }

    getSelectedVariantOptions() {
        const activeSwatch = this.querySelector('.product-color-swatch-wrapper .swatch.active')
        const variantTitle = activeSwatch?.getAttribute('data') || ''
        const variantValues = variantTitle.split('/').map(value => value.trim()).filter(Boolean)
        const optionNames = this.getVariantOptionNames()
        const selectedOptions = variantValues.map(
            (value, index) => `${optionNames[index] || `Option ${index + 1}`} ${value}`
        )

        this.querySelectorAll('.variant_list .variant_item .item.active').forEach((item, index) => {
            if (index + 1 < variantValues.length) {
                return
            }

            const optionName = item.closest('.variant_item')?.querySelector('.variant_name')?.textContent?.trim()
            const optionValue = item.textContent?.trim()

            if (optionName && optionValue) {
                selectedOptions.push(`${optionName} ${optionValue}`)
            }
        })

        return selectedOptions
    }

    getVariantStatusMessage() {
        const productName = this.querySelector('.product_name')?.textContent?.trim() || this.querySelector('.product_top')?.getAttribute('aria-label')?.trim()
        const selectedOptions = this.getSelectedVariantOptions()
        const currentPrice = this.querySelector('.price_list .price.active .cur_price')?.textContent?.trim()
        const comparePrice = this.querySelector('.price_list .price.active .compare_price')?.textContent?.trim()
        const buttonText = this.add_cart_btn?.querySelector('span')?.textContent?.trim()
        const statusParts = []

        if (productName) {
            statusParts.push(productName)
        }

        if (selectedOptions.length) {
            statusParts.push(`Selected variant: ${selectedOptions.join(', ')}`)
        }

        if (currentPrice) {
            statusParts.push(comparePrice ? `Sale price ${currentPrice}, regular price ${comparePrice}` : `Price ${currentPrice}`)
        }

        if (buttonText && /discontinued|notify|sold out/i.test(buttonText)) {
            statusParts.push(buttonText)
        }

        return statusParts.join('. ')
    }

    announceVariantStatus() {
        const activeSwatch = this.querySelector('.product-color-swatch-wrapper .swatch.active')
        const message = this.getVariantStatusMessage().replace(/\s+/g, ' ').trim()

        if (!message) return

        // Update the swatch's accessible name with the full variant summary so
        // keyboard users who move focus back to the swatch can re-read it.
        if (activeSwatch) {
            activeSwatch.setAttribute('aria-label', message)
        }

        // Delegate to the global announcement helper which writes to the body-level
        // live region (#cart-live-region-global). That node is outside any custom
        // element and is always tracked by NVDA's mutation observer, making it far
        // more reliable than a live region nested inside <product-item>.
        if (typeof window.announceCartStatus === 'function') {
            window.announceCartStatus(message)
        }
    }

    ga4Event() {
        const product_sku = this.querySelector('.swatch.active').dataset.sku
        const price = this.querySelector('.price.active .cur_price').textContent.slice(1)
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            "event": "ga4Event",
            "event_name": 'select_item',
            "event_parameters": {
                "currency": "USD",
                "value": price,
                "button": 'image',
                "item_list_id": this.item_name,
                "item_list_name": this.item_name,
                "items": [
                    {
                        "item_list_id": this.item_name,
                        "item_list_name": this.item_name,
                        "item_id": product_sku,
                        "item_name": getProductInfo(product_sku).title,
                        "discount": 0,
                        "index": this.closest('.grid__item').dataset.index,
                        "item_category": getProductInfo(product_sku).name,
                        "item_category2": getProductInfo(product_sku).size,
                        "item_category3": getProductInfo(product_sku).color,
                        "item_variant": getProductInfo(product_sku).type,
                        "item_brand": "SHOKZ",
                        "price": price,
                        "quantity": 1,
                        "currency": "USD"
                    }
                ]
            }
        });
    }

    init() {

        let that = this

        // 如果是促销状态，显示促销时的标签，隐藏分非促销标签
        if (document.querySelector('.section_colllection_fitler').classList.contains('on_sale')) {
            const onSaleTag = this.querySelector('.custom_tag.on_sale')
            if (onSaleTag) {
                Array.from(onSaleTag.parentElement.children).forEach(tag => {
                    tag.classList.contains('on_sale') ? tag.style.display = 'block' : tag.style.display = 'none'
                })
            }
        }


        // 获取所有颜色选择器元素
        this.swatch_ele.forEach(swatch => {
            // 为每个选择器添加点击事件
            swatch.addEventListener('click', function (event) {
                const shouldAnnounceVariantStatus = event.isTrusted || that.announceNextVariantChange
                that.announceNextVariantChange = false

                // 移除所有兄弟元素的active类，为当前元素添加active类
                const siblings = Array.from(this.parentElement.children);
                siblings.forEach(sib => sib.classList.remove('active'));
                this.classList.add('active');
                that.updateSwatchAccessibility(this)

                // 获取当前的color值，如果其他变体项没有该color，设为disabled
                that.active_color = this.getAttribute('data').split('/')[0].trim()

                that.isVariantAnable()

                // 获取variant_id
                const variantId = this.dataset.id;

                // 处理价格显示
                const topWrapper = this.closest('.top_wrapper');
                const priceElements = topWrapper.querySelectorAll('.price_list .price');
                priceElements.forEach(price => {
                    if (price.dataset.id === variantId) {
                        price.classList.add('active');
                    } else {
                        price.classList.remove('active');
                    }
                });

                // 处理图片显示
                const productItem = this.closest('.product_item');
                const variantImages = productItem.querySelectorAll('.variant-img');
                variantImages.forEach(img => {
                    if (img.dataset.id === variantId) {
                        img.classList.remove('hidden');
                    } else {
                        img.classList.add('hidden');
                    }
                });

                // 更新加入购物车按钮的data属性
                that.add_cart_btn.dataset.variantId = variantId;
                if (that.add_cart_btn.dataset.discontinuedid.indexOf(variantId) > -1 || that.add_cart_btn.dataset.discontinuedhandle == 'true') {
                    that.add_cart_btn.classList.remove('notify')
                    that.add_cart_btn.classList.add('disabled')
                    that.add_cart_btn.querySelector('span').textContent = 'Discontinued'
                } else if (this.dataset.varavailable == 'false') {
                    that.add_cart_btn.classList.add('notify')
                    that.add_cart_btn.querySelector('span').textContent = 'Notify Me'
                } else {
                    that.add_cart_btn.classList.remove('disabled', 'notify')
                    // that.add_cart_btn.querySelector('span').textContent = 'Add To Cart'

                    that.add_cart_btn.querySelector('span').textContent = 'Add To Cart'


                    that.add_cart_btn.classList.remove('hidden')
                }

                if (that.enable_color_ga4) {
                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                        event: 'ga4Event',
                        event_name: 'select_content',
                        event_parameters: {
                            content_type: 'color',
                            button_name: this.getAttribute('data').split('/')[0].trim(),
                        },
                    });
                }
                that.enable_color_ga4 = true
                if (shouldAnnounceVariantStatus) {
                    that.announceVariantStatus()
                }
            });
        });

        // 获取所有变体项元素并添加点击事件

        this.variant_item.forEach(item => {
            item.addEventListener('click', function (event) {

                // 给当前项添加active类，移除兄弟项的active类
                const siblings = Array.from(this.parentElement.children);
                siblings.forEach(sib => sib.classList.remove('active'));
                this.classList.add('active');
                that.syncOpenMeet2Title()

                that.show_hide_color()


                // 查找符合条件的第一个swatch元素并触发点击事件
                const color_items = this.closest('.variant_list').querySelector('.product_color_item.active .product-color-swatch-wrapper')
                const targetSwatch = color_items.querySelector(`.swatch:not(.hidden)[data*='${that.active_color}']`) || color_items.querySelector(`.swatch:not(.hidden)`)

                //选择size禁止触发color埋点
                that.enable_color_ga4 = false

                // 如果找到元素则触发点击
                if (targetSwatch) {
                    if (event.isTrusted) {
                        that.announceNextVariantChange = true
                    }
                    targetSwatch.click();
                } else if (event.isTrusted) {
                    that.announceVariantStatus()
                }
                window.dataLayer.push({ event_parameters: null });
                window.dataLayer.push({
                    event: 'ga4Event',
                    event_name: 'select_content',
                    event_parameters: {
                        content_type: this.closest('.variant_item').querySelector('.variant_name').textContent,
                        button_name: this.textContent,
                    },
                });

            });
        });

        // 触发一次改变状态
        // this.querySelector('.product-color-swatch-wrapper .swatch.active').click();

        var notifyClose = this.querySelector('.notify_dialog .close')
        if (notifyClose) {
            notifyClose.addEventListener('click', function () {
                var dialog = this.closest('.notify_dialog') || this.parentElement
                if (typeof window.closeProductNotifyDialog === 'function') {
                    window.closeProductNotifyDialog(dialog)
                } else {
                    dialog.classList.add('hidden')
                }
            })
        }

        // 图片跳转埋点
        this.querySelector('.product_top').addEventListener('click', function () {
            that.ga4Event()
        })


        // 特殊处理：默认选中变体
        // this.querySelector(".swatch[data-id='44043747786952']")?.click()
        this.querySelector(".swatch[data-id='44602028687560']")?.click() // OpenDots ONE
        this.querySelector(".swatch[data-id='44286604312776']")?.click() // OpenFit 2 Beige
        this.querySelector(".swatch[data-id='45121686208712']")?.click() // OpenRun Pro Blue
        this.querySelector(".product_info.openmeet")?.querySelector(".item[data='USB-A']")?.click()
    }
} customElements.define("product-item", ProductCard);

/**
 * Collection Notify Me：优先用页面级共享弹窗（offscreen 渲染，portal 到 body 居中）。
 * 不 innerHTML 克隆 Klaviyo 表单（会丢运行时绑定）；打开时轮询等待真实 email 字段。
 */
(function () {
    var KLAVIYO_FORM_CLASS = 'klaviyo-form-Wc2rQj'
    var POLL_MS = 100
    var POLL_MAX = 40

    function isNotifyFormReady(host) {
        if (!host) return false
        return !!host.querySelector(
            'input[type="email"], input[name="email"], input[autocomplete="email"]'
        )
    }

    function isNotifyFormSuccess(host) {
        if (!host) return false
        if (host.classList.contains('klaviyo-form-success')) return true
        if (host.querySelector('[data-testid="form-component-success"]')) return true
        var form = host.querySelector('form')
        if (!form) return false
        if (form.classList.contains('klaviyo-form-success')) return true
        if (form.querySelector('[data-testid="form-component-success"]')) return true
        // Only treat as success when the email field is gone (thank-you view).
        // Do not match marketing copy like "We'll notify you when available".
        if (isNotifyFormReady(host)) return false
        var text = ((form.innerText || form.textContent || '') + '').replace(/\s+/g, ' ').trim()
        return /thanks for signing up/i.test(text) || /you.?re on the list/i.test(text) || /thanks[!.,]?\s+we/i.test(text)
    }

    function expandKlaviyoFormLayout(host) {
        if (!host) return false
        host.style.setProperty('display', 'block', 'important')
        host.style.setProperty('width', '100%', 'important')
        host.style.setProperty('height', 'auto', 'important')
        host.style.setProperty('min-height', '120px', 'important')
        host.style.setProperty('overflow', 'visible', 'important')

        host.querySelectorAll('form, form > div, [data-testid="form-row"], [data-testid="form-component"]').forEach(function (el) {
            el.style.setProperty('flex', '0 0 auto', 'important')
            el.style.setProperty('flex-grow', '0', 'important')
            el.style.setProperty('flex-shrink', '0', 'important')
            el.style.setProperty('flex-basis', 'auto', 'important')
            el.style.setProperty('width', '100%', 'important')
            el.style.setProperty('max-width', '100%', 'important')
            el.style.setProperty('height', 'auto', 'important')
            el.style.setProperty('min-height', 'auto', 'important')
            el.style.setProperty('overflow', 'visible', 'important')
        })

        host.querySelectorAll('input, button, textarea').forEach(function (el) {
            if (el.type === 'submit' || el.tagName === 'BUTTON') {
                el.style.setProperty('width', '100%', 'important')
                el.style.setProperty('min-height', '44px', 'important')
                el.style.setProperty('height', 'auto', 'important')
            } else if (el.type === 'email' || el.type === 'text') {
                el.style.setProperty('width', '100%', 'important')
                el.style.setProperty('min-height', '44px', 'important')
                el.style.setProperty('height', 'auto', 'important')
                el.style.setProperty('display', 'block', 'important')
            }
        })

        return isNotifyFormReady(host)
    }

    function createFreshKlaviyoHost() {
        var fresh = document.createElement('div')
        fresh.className = KLAVIYO_FORM_CLASS
        fresh.setAttribute('data-collection-notify-form', '')
        return fresh
    }

    // Move a live, already-mounted Klaviyo host into the shared dialog.
    // Never copy via innerHTML — that drops Klaviyo runtime bindings.
    function adoptReadyFormIntoShared(dialog, host) {
        if (!dialog) return null
        var donors = Array.from(
            document.querySelectorAll('.notify_dialog [class*="klaviyo-form-"]')
        ).filter(function (el) {
            return !el.closest('#collection-notify-dialog')
        })

        var donor =
            donors.find(function (el) {
                if (!isNotifyFormReady(el) || isNotifyFormSuccess(el)) return false
                var li = el.closest('li')
                return !li || window.getComputedStyle(li).display !== 'none'
            }) ||
            donors.find(function (el) {
                return isNotifyFormReady(el) && !isNotifyFormSuccess(el)
            })

        if (!donor) return host || null

        var placeholder = createFreshKlaviyoHost()
        if (donor.parentNode) {
            donor.parentNode.insertBefore(placeholder, donor)
        }

        if (host && host.parentNode) {
            host.replaceWith(donor)
        } else {
            var closeBtn = dialog.querySelector('.close')
            if (closeBtn) dialog.insertBefore(donor, closeBtn)
            else dialog.appendChild(donor)
        }
        return donor
    }

    function ensureSharedNotifyHost(dialog) {
        if (!dialog || dialog.id !== 'collection-notify-dialog') return null
        var host = dialog.querySelector('[class*="klaviyo-form-"]')
        if (!host) {
            host = createFreshKlaviyoHost()
            var closeBtn = dialog.querySelector('.close')
            if (closeBtn) dialog.insertBefore(host, closeBtn)
            else dialog.appendChild(host)
        }
        if (isNotifyFormReady(host) && !isNotifyFormSuccess(host)) return host
        // Empty or thank-you: adopt a live form from a card dialog when possible.
        // Do not replaceWith an empty host — Klaviyo will not remount it.
        return adoptReadyFormIntoShared(dialog, host) || host
    }

    function waitForNotifyForm(host, done) {
        if (!host) {
            if (done) done(false)
            return
        }
        var attempts = 0
        function tick() {
            if (expandKlaviyoFormLayout(host)) {
                if (done) done(true)
                return
            }
            attempts += 1
            if (attempts >= POLL_MAX) {
                if (done) done(false)
                return
            }
            setTimeout(tick, POLL_MS)
        }
        tick()
    }

    function getSharedNotifyDialog() {
        var dialogs = Array.from(document.querySelectorAll('#collection-notify-dialog'))
        if (!dialogs.length) return null

        // Facet AJAX re-injects another shared dialog. Prefer in this order:
        // currently open → body + ready → any ready → body → first.
        var open = dialogs.find(function (dialog) {
            return !dialog.classList.contains('is-offscreen')
        })
        if (open) return open

        var bodyReady = dialogs.find(function (dialog) {
            return (
                dialog.parentNode === document.body &&
                isNotifyFormReady(dialog.querySelector('[class*="klaviyo-form-"]'))
            )
        })
        if (bodyReady) return bodyReady

        var ready = dialogs.find(function (dialog) {
            return isNotifyFormReady(dialog.querySelector('[class*="klaviyo-form-"]'))
        })
        if (ready) return ready

        var onBody = dialogs.find(function (dialog) {
            return dialog.parentNode === document.body
        })
        return onBody || dialogs[0]
    }

    function dedupeSharedNotifyDialogs() {
        var dialogs = Array.from(document.querySelectorAll('#collection-notify-dialog'))
        if (!dialogs.length) return null

        var keep = getSharedNotifyDialog()
        dialogs.forEach(function (dialog) {
            if (dialog !== keep) dialog.remove()
        })
        if (keep) {
            portalNotifyDialog(keep)
            bindSharedNotifyClose(keep)
        }
        return keep
    }

    function bindSharedNotifyClose(dialog) {
        if (!dialog || dialog.__notifyCloseBound) return
        dialog.__notifyCloseBound = true
        var closeBtn = dialog.querySelector('.close')
        if (!closeBtn) return
        closeBtn.addEventListener('click', function () {
            window.closeProductNotifyDialog(dialog)
        })
        closeBtn.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                window.closeProductNotifyDialog(dialog)
            }
        })
    }

    function portalNotifyDialog(target) {
        if (!target.__notifyHome && target.parentNode && target.parentNode !== document.body) {
            target.__notifyHome = {
                parent: target.parentNode,
                next: target.nextSibling,
            }
        }
        if (target.parentNode !== document.body) {
            document.body.appendChild(target)
        }
    }

    window.closeProductNotifyDialog = function (dialog) {
        if (!dialog) return
        if (dialog.id === 'collection-notify-dialog') {
            dialog.classList.add('is-offscreen')
            dialog.setAttribute('aria-hidden', 'true')
            // Keep the mounted Klaviyo host. Destroying it prevents remount.
            return
        }
        dialog.classList.add('hidden')
        dialog.classList.remove('is-portaled')
        var home = dialog.__notifyHome
        if (home && home.parent && document.body.contains(home.parent)) {
            if (home.next && home.next.parentNode === home.parent) {
                home.parent.insertBefore(dialog, home.next)
            } else {
                home.parent.appendChild(dialog)
            }
        }
    }

    window.openProductNotifyDialog = function (dialog) {
        var shared = dedupeSharedNotifyDialogs() || getSharedNotifyDialog()
        var target = shared || dialog
        if (!target) return

        document.querySelectorAll('.notify_dialog').forEach(function (openDialog) {
            if (openDialog === target) return
            if (openDialog.id === 'collection-notify-dialog') {
                if (!openDialog.classList.contains('is-offscreen')) window.closeProductNotifyDialog(openDialog)
                return
            }
            if (!openDialog.classList.contains('hidden')) window.closeProductNotifyDialog(openDialog)
        })

        bindSharedNotifyClose(target)
        // Portal to body so position:fixed centers on the viewport
        // (.scroll-trigger ancestors create a containing block via transform).
        portalNotifyDialog(target)

        if (target.id !== 'collection-notify-dialog') {
            target.classList.add('is-portaled')
            target.classList.remove('hidden')
        } else {
            ensureSharedNotifyHost(target)
            target.classList.remove('is-offscreen')
        }
        target.setAttribute('aria-hidden', 'false')

        var host = target.querySelector('[class*="klaviyo-form-"]')
        if (!host) return
        waitForNotifyForm(host)
    }

    function watchCollectionGridForNotifyDialog() {
        var grid = document.getElementById('ProductGridContainer')
        if (!grid || grid.__notifyDedupeObserver || typeof MutationObserver === 'undefined') return
        grid.__notifyDedupeObserver = true
        var timer = null
        var observer = new MutationObserver(function () {
            clearTimeout(timer)
            timer = setTimeout(function () {
                dedupeSharedNotifyDialogs()
            }, 50)
        })
        observer.observe(grid, { childList: true, subtree: true })
    }

    document.addEventListener('DOMContentLoaded', function () {
        dedupeSharedNotifyDialogs()
        watchCollectionGridForNotifyDialog()
    })
})();

/**
 * AddCartButton，加购按钮，点击元素本身触发
 *
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 *
 * @example
 * ```html
 * <add-cart-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Add to cart
 *   {%- render 'loading-spinner' -%}
 * </add-cart-button>
 * ```
 */
if (!customElements.get('add-cart-button')) {
    class AddCartButton extends ProductCard {
        // 标记
        _marks = {
            loading: "loading"
        };

        _shopify_features_script = document.querySelector("script[id='shopify-features']");
        _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
        _checkout_headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
        };

        get _variantId() { return this.getAttribute("data-variant-id") }
        get _quantity() { return this.getAttribute("data-quantity") ?? 1 }

        constructor() {
            super();
        }

        connectedCallback() {
            this.elements = {
                loadingSpinner: this.querySelector(".loading__spinner"),
            };
            let that = this
            this.addEventListener('click', (e) => {
                if (that.className.indexOf('disabled') > -1) {
                    this.ga4Event('select_item', 'discontinued')
                    return
                } else if (that.className.indexOf('notify') > -1) {
                    e.preventDefault()
                    e.stopPropagation()
                    var dialog = that.nextElementSibling
                    if (typeof window.openProductNotifyDialog === 'function') {
                        window.openProductNotifyDialog(dialog)
                    } else if (dialog) {
                        dialog.classList.remove('hidden')
                    }
                    this.ga4Event('select_item', 'notify me')
                } else {
                    this.startLoading();
                    this.addToCart().finally(() => {
                        this.finishLoading();
                    });
                    this.ga4Event('add_to_cart', 'add to cart')
                }
            });
        }



        // 埋点
        ga4Event(eventName, buttonName) {
            const product_sku = this.closest('.top_wrapper').querySelector('.swatch.active').dataset.sku
            const price = this.closest('.top_wrapper').querySelector('.price.active .cur_price').textContent.slice(1)
            const comp_price = this.closest('.top_wrapper').querySelector('.price.active .compare_price')?.textContent.slice(1) || 0
            let discount = comp_price && parseFloat(comp_price) > parseFloat(price) ? parseFloat(comp_price) - parseFloat(price) : 0
            discount = Math.floor(discount)
            window.dataLayer.push({ "event_parameters": null });
            window.dataLayer.push({
                "event": "ga4Event",
                "event_name": eventName,
                "event_parameters": {
                    "currency": "USD",
                    "value": price,
                    "button": buttonName,
                    "item_list_id": this.item_name,
                    "item_list_name": this.item_name,
                    "items": [
                        {
                            "item_list_id": this.item_name,
                            "item_list_name": this.item_name,
                            "item_id": product_sku,
                            "item_name": getProductInfo(product_sku).title,
                            "discount": discount,
                            "index": this.closest('.grid__item').dataset.index,
                            "item_category": getProductInfo(product_sku).name,
                            "item_category2": getProductInfo(product_sku).size,
                            "item_category3": getProductInfo(product_sku).color,
                            "item_variant": getProductInfo(product_sku).type,
                            "item_brand": "SHOKZ",
                            "price": price,
                            "quantity": 1,
                            "currency": "USD"
                        }
                    ]
                }
            });
        }

        /**
         * 加购
         */
        async addToCart() {
            let data_json = {
                form_type: "product",
                quantity: this._quantity,
                utf8: "✓",
                id: this._variantId,
            }
            let data = JSON.stringify(data_json);
            return fetch("/cart/add.json",
                {
                    method: 'POST',
                    headers: this._checkout_headers,
                    body: data
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }
            }).then((response) => {
                return this.updateCart(response);
            }).catch((err) => {
                console.error(err);
            });
        }

        /**
         * 更新购物车，并弹出侧边购物车
         * @returns
         */
        async updateCart(response) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
                // source: 'product-form',
                productVariantId: this._variantId,
                cartData: response,
            });
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                // Set message before open() so it's announced after transitionend + trapFocus
                cartDrawer.pendingOpenAnnouncement =
                    typeof window.getCartAddedMessage === 'function'
                        ? window.getCartAddedMessage(response)
                        : window.cartStrings?.itemAdded || '';
                cartDrawer.open();
            }

            if ($(".cart-items").length < 1) {
                $(`cart-drawer`).removeClass("is-empty");
                $(".drawer__inner-empty").remove();
                $("#CartDrawer-Checkout").removeAttr("disabled");
            }
        }

        startLoading() {
            this.setAttribute("aria-disabled", true);
            this.classList.add(this._marks.loading);
            this.elements.loadingSpinner?.classList.remove("hidden");
        }

        finishLoading() {
            this.removeAttribute("aria-disabled");
            this.classList.remove(this._marks.loading);
            this.elements.loadingSpinner?.classList.add("hidden");
        }
    }

    customElements.define('add-cart-button', AddCartButton);
}
